(function () {
  class PeachabooCart {
    selectors = {
      saleDiscount: '[data-sale-discount]',
      rootTotal: '[data-root-total]'
    };

    form = null;

    constructor(form) {
      this.form = form;

      this.saleDiscount = form.querySelector(this.selectors.saleDiscount);
      this.rootTotal = form.querySelector(this.selectors.rootTotal);

      document.addEventListener("cart:updated", this.onCartUpdateCallback.bind(this));
    }

    onCartUpdateCallback(e) {
      // console.log(e);
      
      let cartItems = e.detail.cart.items;
      let prices = this.parseCart(cartItems);
      // console.log(prices);
      this.cartMarkup(prices);
    }

    cartMarkup(prices){
      this.saleDiscount.innerHTML = theme.Currency.formatMoney(prices.sale, theme.settings.moneyFormat);
      this.rootTotal.innerHTML = theme.Currency.formatMoney(prices.root, theme.settings.moneyFormat);
    }
    
    parseCart(cartItems){
      let salePrice = 0;
      let rootPrice = 0;

      cartItems.forEach(element => {
        let key = element.key;
        let line_item = this.form.querySelector("[data-key='" + key + "']");
        let price = line_item.dataset.price ? parseFloat(line_item.dataset.price) : 0;
        let orgPrice = line_item.dataset.orgPrice ? parseFloat(line_item.dataset.orgPrice) : 0;
        let savePrice = 0;
  
        if(orgPrice != ""){
          savePrice = (orgPrice - price) * element.quantity;
          rootPrice += orgPrice * element.quantity;
        }
        else{
          rootPrice += price * element.quantity;
        }

        salePrice += savePrice;
      });
      
      return {sale: salePrice, root: rootPrice};
    }

  }

  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  DOMready(function () {
    var cartPageForm = document.getElementById('CartPageForm');

    if(cartPageForm != null) {
      new PeachabooCart(cartPageForm);
    }
    
  });
})();